import actionCreatorFactory from 'typescript-fsa';
import { AgencyInfo, SelectedStoresArray, StoreAndAgencyInfo } from '../reducers/StoreSelectorReducer';
import { filterKeyState, filterConditionState } from '../reducers/CurrentFilterReducer';
import { customCountListState } from '../reducers/CustomCountListReducer';
import { MailTopState } from '../reducers/MailTopReducer';
import { MailDetailResultState } from '../reducers/MailDetailResultReducer';
import { negotiationCountState } from '../reducers/NegotiationCountReducer';
import { SearchConditionState } from '../reducers/SearchConditionReducer';
import { responseType } from '../../utils/TableCells';
import { SearchResultState } from '../reducers/SearchResultReducer';
import { RefreshState } from '../reducers/RefreshReducer';
import { CommonResult } from '../../external/Common';
import { LoadingType } from '../reducers/LoadingStatusReducer';
import { SearchCategoryState } from '../reducers/SearchCategoryReducer';
import { ErrorParameter, SorryMessageState } from '../reducers/SorryMessageReducer';
import { MailTemplateState } from '../reducers/MailTemplateReducer';
import { ApplyStaffState } from '../reducers/ApplyStaffReducer';
import { MailCreateState } from '../reducers/MailCreateReducer';
import { MailSaveState } from '../reducers/MailSaveReducer';
import { MailDeleteState } from '../reducers/MailDeleteReducer';
import { MailTemplateApplyState } from '../reducers/MailTemplateApplyReducer';
import { MailTemplateDetailState } from '../reducers/MailTemplateDetailReducer';
import { MailAddressSelectState } from '../reducers/MailAddressSelectReducer';
import { MailDraftState } from '../reducers/MailDraftReducer';
import { MailStopState } from '../reducers/MailStopReducer';
import { MailStopDoneState } from '../reducers/MailStopDoneReducer';
import { masterDetailState } from '../reducers/MasterDetailReducer';
import { MasterInfoState } from '../reducers/MasterInfoReducer';
import { MessageDisplayMethodInfo } from '../../external/MessageDisplayMethodListApi';
import { CommodityCategoryContractInfo, SearchBranch } from '../../external/AggregationApi';
import { searchBranchStatusState } from '../reducers/SearchBranchStatusReducer';
import { StoreInfo } from '../../external/StoresApi';
import { MailDeliveryStopState } from '../reducers/MailDeliveryStopReducer';
import { AgencyDetailInfo } from '../../external/AgencyDetailApi';
import { DevConsoleConfig } from '../reducers/DevConsoleReducer';
import { ConsentInfoState } from '../reducers/ConsentInfoReducer';
import { VisitReservationStoreInfo } from '../reducers/VisitReservationInfoReducer';
import { VisitReservationInfoState, VisitReservationListInfo, VisitReservationSummaryInfo } from '../reducers/VisitReservationInfoReducer';
import { GetVisitSummaryApiRequest } from '../../external/VisitApi';
import { CustomerInfoAllState } from '../reducers/CustomerInfoAllReducer';

const actionCreator = actionCreatorFactory();

export const actions = {
  updateCurrentFilter: actionCreator<filterKeyState>('UPDATE_CURRENT_FILTER'),
  clearFilter: actionCreator<void>('CLEAR_CURRENT_FILTER'),
  fetchCustomCountList: actionCreator<customCountListState>('FETCH_CUSTOM_COUNT_LIST'),
  fetchNegotiationCount: actionCreator<negotiationCountState>('FETCH_NEGOTIATION_COUNT'),
  fetchMailTop: actionCreator<MailTopState>('FETCH_MAIL_TOP'),
  fetchMailDetail: actionCreator<MailDetailResultState>('FETCH_MAIL_DETAIL_RESULT'),
  fetchMailTemplate: actionCreator<MailTemplateState>('FETCH_MAIL_TEMPLATE'),
  fetchMailTemplateDetail: actionCreator<MailTemplateDetailState>('FETCH_MAIL_TEMPLATE_DETAIL'),
  fetchApplyStaff: actionCreator<ApplyStaffState>('FETCH_APPLY_STAFF'),
  fetchMailTempMstList: actionCreator<MailCreateState>('FETCH_MAIL_TEMP_MST_LIST'),
  applyMailTemplate: actionCreator<MailTemplateApplyState>('APPLY_MAIL_TEMPLATE'),
  saveMailDraft: actionCreator<MailSaveState>('SAVE_MAIL_DRAFT'),
  deleteMailDraft: actionCreator<MailDeleteState>('DELETE_MAIL_DRAFT'),
  fetchMailAddressSelect: actionCreator<MailAddressSelectState>('FETCH_MAIL_ADDRESS_SELECT'),
  fetchMailDraft: actionCreator<MailDraftState>('FETCH_MAIL_DRAFT'),
  fetchMailStop: actionCreator<MailStopState>('FETCH_MAIL_STOP'),
  fetchMailDeliveryStop: actionCreator<MailDeliveryStopState>('FETCH_MAIL_DELIVERY_STOP'),
  fetchMailStopDone: actionCreator<MailStopDoneState>('FETCH_MAIL_STOP_DONE'),
  fetchMasterDetail: actionCreator<masterDetailState>('FETCH_MASTER_DETAIL'),
  updateSearchResult: actionCreator<SearchResultState>('UPDATE_SEARCH_RESULT'),
  updateSearchCondition: actionCreator<SearchConditionState>('UPDATE_SEARCH_CONDITION'),
  storeSelector: {
    initialize: {
      store: actionCreator<StoreInfo[]>('INITIALIZE_WITH_STORE'),
      agency: actionCreator<AgencyInfo[]>('INITIALIZE_WITH_AGENCY'),
      agencyDetail: actionCreator<AgencyDetailInfo>('INITIALIZE_WITH_AGENCY_DETAIL'),
    },
    toggleStore: actionCreator<StoreAndAgencyInfo>('TOGGLE_STORE'),
    updateSelectedStores: actionCreator<SelectedStoresArray>('UPDATE_TARGET_STORE'),
    toggleModal: actionCreator<void>('TOGGLE_STORE_SELECTOR_MODAL'),
    clearSelectedStores: actionCreator<void>('CLEAR_SELECTED_STORES'),
    selectAllStores: actionCreator<void>('SELECT_ALL_STORES'),
    selectOnlyStoresInCharge: actionCreator<void>('SELECT_ONLY_STORES_IN_CHARGE'),
  },
  updateNegotiation: {
    result: actionCreator<responseType>('UPDATE_NEGOTIATION_RESULT'),
    period: actionCreator<responseType>('UPDATE_NEGOTIATION_PERIOD'),
    pending: actionCreator<responseType>('UPDATE_NEGOTIATION_PENDING'),
    pendingHeaderDisp: actionCreator<string>('UPDATE_NEGOTIATION_PENDING_HEADER_DISP'),
    action: actionCreator<responseType>('UPDATE_NEGOTIATION_ACTION'),
    prob: actionCreator<responseType>('UPDATE_NEGOTIATION_PROB'),
  },
  updateSearchBranch: {
    result: actionCreator<{ [key: string]: SearchBranch }>('UPDATE_SEARCH_BRANCH_RESULT'),
    period: actionCreator<{ [key: string]: SearchBranch }>('UPDATE_SEARCH_BRANCH_PERIOD'),
    pending: actionCreator<{ [key: string]: SearchBranch }>('UPDATE_SEARCH_BRANCH_PENDING'),
    action: actionCreator<{ [key: string]: SearchBranch }>('UPDATE_SEARCH_BRANCH_ACTION'),
    prob: actionCreator<{ [key: string]: SearchBranch }>('UPDATE_SEARCH_BRANCH_PROB'),
    status: actionCreator<searchBranchStatusState>('UPDATE_SEARCH_BRANCH_STATUS'),
    commodityCategoryContract: actionCreator<CommodityCategoryContractInfo>('UPDATE_SEARCH_BRANCH_COMMODITY_CATEGORY_CONTRACT'),
  },
  updateRefresh: actionCreator<RefreshState>('UPDATE_REFRESH'),
  updateSearchCategory: actionCreator<SearchCategoryState>('UPDATE_SEARCH_CATEGORY'),
  filterList: {
    update: actionCreator<filterConditionState[]>('FILTERLIST_UPDATE'),
  },
  updateNotificationStatus: actionCreator<{ screenId: string; messageType: string; messageText?: string }>('UPDATE_NOTIFICATION_STATUS'),
  refreshNotificationStatus: actionCreator<string>('REFRESH_NOTIFICATION_STATUS'),
  updateLoadingStatus: actionCreator.async<
    LoadingType, // params
    CommonResult | undefined, // result
    {} // error
  >('UPDATE_LOADING_STATUS'),
  refreshLoadingStatus: actionCreator<LoadingType>('REFRESH_LOADING_STATUS'),
  updateSorryMessage: actionCreator<SorryMessageState>('UPDATE_SORRY_MESSAGE'),
  fetchMasterInfo: actionCreator<MasterInfoState>('FETCH_MASTER_INFO'),
  updateErrMessage: {
    errorDetail: actionCreator<ErrorParameter>('UPDATE_SORRY_MESSAGE_RESULT'),
    messageDisplayMethodList: actionCreator<Array<MessageDisplayMethodInfo>>('UPDATE_SORRY_MESSAGE_MST'),
  },
  devConsole: {
    init: actionCreator<void>('DEV_CONSOLE_INIT'),
    configure: actionCreator<DevConsoleConfig>('DEV_CONSOLE_CONFIGURE'),
    output: actionCreator<string>('DEV_CONSOLE_OUTPUT'),
    devConsoleModalOpen: actionCreator<void>('DEV_CONSOLE_MODAL_OPEN'),
    devConsoleModalClose: actionCreator<void>('DEV_CONSOLE_MODAL_CLOSE'),
  },
  // 許諾情報アクション
  updateConsentInfo: actionCreator<ConsentInfoState>('UPDATE_CONSENT_INFO'),
  /** 来店予約情報ストアのアクション */
  visitReservationInfo: {
    init: actionCreator<void>('INIT_VISIT_RESERVATION_INFO'),
    updateVisitReservationInfo: actionCreator<VisitReservationInfoState>('UPDATE_VISIT_RESERVATION_INFO'),
    updateStoreList: actionCreator<Array<VisitReservationStoreInfo>>('UPDATE_VISIT_RESERVATION_STORE_LIST'),
    updateGetSummaryApiRequest: actionCreator<GetVisitSummaryApiRequest>('UPDATE_VISIT_RESERVATION_GET_SUMMARY_API_REQUEST'),
    updateSummaryInfo: actionCreator<VisitReservationSummaryInfo>('UPDATE_VISIT_RESERVATION_SUMMARY_INFO'),
    updateListInfo: actionCreator<VisitReservationListInfo>('UPDATE_VISIT_RESERVATION_LIST_INFO'),
  },
  /** サマリー画面用 顧客全情報取得アクション*/
  fetchCustomerInfoAll: {
    init: actionCreator<void>('INIT_CUSTOMER_INFO_ALL'),
    fetch: actionCreator<CustomerInfoAllState>('FETCH_CUSTOMER_INFO_ALL'),
  },
};
